module.exports = __webpack_public_path__ + "static/media/996731.60422646.png";